import { isUrlExisted } from "./Common";
import { ValidVideo, VideoSource } from "./class/common/video";

export const videoSuffix = {
  sd: "_1200kbps.mp4",
  hd: "_2500kbps.mp4"
}

export const generateVideoSource = (sdSrc?: string | null, hdSrc?: string | null, videoValidation?: ValidVideo) => {
  let sources = [] as VideoSource[];
  if (sdSrc && (!videoValidation || videoValidation.sdSrc)) {
    sources.push(new VideoSource("sd", sdSrc))
  }
  if (hdSrc && (!videoValidation || videoValidation.hdSrc)) {
    sources.push(new VideoSource("hd", hdSrc))
  }
  return sources
}

export const generateVideoUrl = (path: string) => { // keep fixiblity on video format support
  const domain = "https://streaminghkjc-a.akamaihd.net/hdflash"
  const middlePath = (path.startsWith("/") ? path : "/" + path)
  return {
    sd: domain + middlePath + videoSuffix.sd,
    hd: domain + middlePath + videoSuffix.hd,
  }
}

export const validateVideo = async (url: any) => {
    if (!url) return new ValidVideo(false, false); 
    const sdSrc = url.sd ? await isUrlExisted(url.sd) : false;
    const hdSrc = url.hd ? await isUrlExisted(url.hd) : false;
    return new ValidVideo(sdSrc, hdSrc);
}